module.exports = __webpack_public_path__ + "static/img/chat.95d8c65.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/website/chat.svg
// module id = pIqt
// module chunks = 1